import React from 'react';
import { ContentCard } from '../components';
import { providedServices } from '../utils/text-data';
import clsx from 'clsx';

export const ServicesSection = () => {
  const getColor = (param: number) => {
    switch (param + 1) {
      default:
      case 1:
        return 'bg-skyBlue';
      case 2:
        return 'bg-pink';
      case 3:
        return 'bg-yellow';
    }
  };

  return (
    <ContentCard cardTitle={'Services'} className='gap-3'>
      {providedServices?.map((item, key) => (
        <div className='flex flex-col gap-3 md:flex-row'>
          <div
            className={clsx(
              'w-fit md:w-10 p-3 md:p-6 flex items-center justify-start md:justify-center rounded-radi-md',
              getColor(key)
            )}>
            <h1>{key + 1}.</h1>
          </div>
          <div className={clsx('flex flex-wrap flex-col w-full px-6 py-3 rounded-radi-md', getColor(key))}>
            <h3>{item?.title}</h3>
            <p className='text-base tracking-normal'>{item?.description}</p>
          </div>
        </div>
      ))}
    </ContentCard>
  );
};
